import moment from 'moment';
import React from 'react';
import { ACTIVE_BILLING_PLANS, LEGACY_BILLING_PLANS } from '../constants';
import { FlagsContext } from '../context';
import { useCustomerSubscription } from './useCustomerSubscription';

export const activeBillingPlans = Object.values(ACTIVE_BILLING_PLANS);

export const usePlanInfo = () => {
  const { EnableNewPricingPlans } = React.useContext(FlagsContext);
  const { stripeCustomer, customerSubscription } = useCustomerSubscription();

  const {
    planName,
    currentPeriodEndDate,
    cancelAtPeriodEnd,
    isLegacyEnterprisePlan,
    isLegacyPlan,
  } = React.useMemo(() => {
    const mainSubscriptionItem = customerSubscription?.items?.data[0];

    let plan = '';
    if (mainSubscriptionItem?.price.id.includes('pro')) {
      plan = 'Professional plan';
    } else if (mainSubscriptionItem?.price.id.includes('basic')) {
      plan = 'Basic plan';
    } else if (mainSubscriptionItem?.price.id.includes('standard')) {
      plan = 'Standard plan';
    } else if (mainSubscriptionItem?.price.id.includes('enterprise')) {
      plan = 'Enterprise plan';
    } else if (mainSubscriptionItem?.price.id.includes('starter')) {
      plan = 'Starter Plan';
    } else if (mainSubscriptionItem?.price.id.includes('professional')) {
      plan = 'Professional Plan';
    } else if (mainSubscriptionItem?.price.id.includes('advanced')) {
      plan = 'Advanced Plan';
    }

    const periodEndDate = customerSubscription
      ? moment(new Date(customerSubscription.current_period_end * 1000)).format(
          'MMMM Do, YYYY',
        )
      : undefined;

    return {
      planName: plan,
      currentPeriodEndDate: periodEndDate,
      cancelAtPeriodEnd: Boolean(customerSubscription?.cancel_at_period_end),
      isLegacyPlan:
        EnableNewPricingPlans &&
        Boolean(customerSubscription) && // In case of trial plan, customer subscription is undefined. Also, trial plan is not legecy plan
        !activeBillingPlans.includes(
          mainSubscriptionItem?.price.id as ACTIVE_BILLING_PLANS,
        ),
      isLegacyEnterprisePlan:
        EnableNewPricingPlans &&
        mainSubscriptionItem?.price.id === LEGACY_BILLING_PLANS.ENTERPRISE,
    };
  }, [stripeCustomer, customerSubscription, EnableNewPricingPlans]);

  return {
    planName,
    currentPeriodEndDate,
    cancelAtPeriodEnd,
    isLegacyEnterprisePlan,
    isLegacyPlan,
  };
};
